import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserHostVersionGuardService } from '@portal-core/auth/guards/browser-host-version-guard.service';
import { LicenseURLPageComponent } from '@portal-login/login/components/license-url-page/license-url-page.component';
import { LoginPageComponent } from '@portal-login/login/components/login-page/login-page.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [BrowserHostVersionGuardService],
    component: LoginPageComponent
  },
  {
    path: 'login/license',
    component: LicenseURLPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
